import { render } from "./ShareInformation.vue?vue&type=template&id=7da50b04&scoped=true"
import script from "./ShareInformation.vue?vue&type=script&lang=js"
export * from "./ShareInformation.vue?vue&type=script&lang=js"

import "./ShareInformation.vue?vue&type=style&index=0&id=7da50b04&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites safe 2026/Safe_Sites_Modifs/SAFE_GROUP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da50b04"]])

export default __exports__